import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Adatkezeles() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="privacy-page" className="min-h-screen bg-[#F0F1F5] text-gray-900">
      <div className="max-w-4xl mx-auto px-6 py-16 md:py-24">
        <Link to="/" className="text-violet-300 hover:text-violet-200 text-sm font-bold uppercase tracking-wider">
          ← Vissza a főoldalra
        </Link>
        <h1 className="mt-6 font-display text-3xl md:text-5xl font-black uppercase tracking-tighter">
          Adatkezelési tájékoztató
        </h1>
        <p className="mt-2 text-gray-400 text-sm">Hatályos: 2026. július 1.</p>

        <div className="mt-10 space-y-8 text-gray-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">1. Adatkezelő</h2>
            <p>Pitstop Tire Kft</p>
            <p>Székhely: [Székhely]</p>
            <p>Adószám: [Adószám]</p>
            <p>Cégjegyzékszám: [Cégjegyzékszám]</p>
            <p>E-mail: fastpower.gumi@gmail.com</p>
            <p>Telefon: +36 30 511 4205</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">2. A kezelt adatok köre</h2>
            <p>Rendelés / kapcsolatfelvétel során a következő adatokat kezeljük:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>név, telefonszám, e-mail cím,</li>
              <li>szállítási / szerelési cím,</li>
              <li>céges megrendelés esetén: cégnév, adószám, számlázási cím,</li>
              <li>megjegyzés (opcionális).</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">3. Adatkezelés célja és jogalapja</h2>
            <p>Az adatokat kizárólag a rendelés teljesítése, számlázás és kapcsolattartás céljából kezeljük. A jogalap a szerződés teljesítése (GDPR 6. cikk (1) b) és a számviteli jogszabályokon alapuló kötelezettség.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">4. Sütik (cookies)</h2>
            <p>A weboldalon a Google Tag Manager (GTM) és egyedi analitika (PostHog) sütiket használ. Ezek a sütik a látogatottsági statisztikához szükségesek, és csak az Ön hozzájárulása esetén kerülnek letöltésre. A hozzájárulást az oldal alján megjelenő süti-sávban adhatja meg vagy utasíthatja el.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">5. Adattovábbítás</h2>
            <p>Az adatokat harmadik félnek nem adjuk át, kivéve a jogszabály által előírt esetekben (pl. könyvelő). A szolgáltatás üzemeltetéséhez szükséges informatikai szolgáltatók adatfeldolgozóként működnek közre.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">6. Jogai</h2>
            <p>Ön jogosult az adataihoz való hozzáféréshez, helyesbítéshez, törléshez, korlátozáshoz és tiltakozáshoz. Kérését a fastpower.gumi@gmail.com címre küldheti. Panasz esetén a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (NAIH) fordulhat.</p>
          </section>
        </div>
      </div>
    </main>
  );
}
